import { useEffect, useRef, useState } from 'react'

import type { ChatStatusMessageItemState } from './types/ChatStatusMessageTypes'

// Open while the status loads, closed when it is done (or when it is done from the start). The user can toggle it.
const useCollapsibleStatus = (state: ChatStatusMessageItemState | undefined) => {
    const [isExpanded, setIsExpanded] = useState(() => state !== 'done')
    const prevStateRef = useRef(state)

    useEffect(() => {
        if (prevStateRef.current !== 'done' && state === 'done') {
            setIsExpanded(false)
        }
        prevStateRef.current = state
    }, [state])

    const toggle = () => setIsExpanded(v => !v)

    return { isExpanded, toggle }
}

export default useCollapsibleStatus
